module.exports = __webpack_public_path__ + "img/need-upload.efb2babf.svg";